import { startOfISOWeek, addWeeks, addDays, format } from 'date-fns';

export function demoTimesheets(week, year) {
  const start = addWeeks(startOfISOWeek(new Date(year, 0, 4)), week - 1);
  return [
    ['Camille Martin', 'Électricien', 'Bâtiment Horizon', '3060', 0, 'a_saisir'],
    ['Alex Moreau', 'Manutentionnaire', 'Logistique Atlas', '3050', 1, 'a_saisir'],
    ['Sarah Bernard', 'Assistante administrative', 'Bureau Lumière', '3072', 0, 'a_valider'],
    ['Hugo Petit', 'Maçon', 'Bâtiment Horizon', '3061', 2, 'a_saisir'],
    ['Léa Dubois', 'Préparatrice de commandes', 'Logistique Atlas', '3085', 1, 'a_valider'],
    ['Noah Roux', 'Technicien de maintenance', 'Industrie Nova', '3090', 0, 'integrated'],
  ].map(([employeeName, employeePosition, clientName, contractNumber, amendmentNumber, status], index) => ({
    id: `demo-rh-${year}-${week}-${index}`, isDemo: true,
    employeeName, employeePosition, clientName, employeeCompany: clientName,
    employeeId: `DEMO-${index + 1}`, contractNumber, amendmentNumber,
    contractReference: `${contractNumber}.${amendmentNumber}`,
    weekNumber: week, year, startDate: format(start, 'yyyy-MM-dd'), endDate: format(addDays(start, 6), 'yyyy-MM-dd'),
    status, hours: { lundi: '7', mardi: '7', mercredi: '7', jeudi: '7', vendredi: '7' },
    nightHours: {}, absences: {}, heures: [], primes: [],
  }));
}
